import { Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { issueTypePrioritySortFn } from "@overmap-ai/common"
import { useSort } from "@overmap-ai/hooks"
import { memo, type ReactElement } from "react"

import {
	IssuePriorityMultiSelectGroup,
	type IssuePriorityMultiSelectGroupProps,
} from "../MenuMultiSelectGroups/IssuePriorityMultiSelectGroup"

export interface IssuePriorityMultiSelectProps
	extends
		MenuRootProps,
		IssuePriorityMultiSelectGroupProps,
		MenuVariantProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const IssuePriorityMultiSelect = memo((props: IssuePriorityMultiSelectProps) => {
	const { children, values, priorities, onValuesChange, disabled, variant, size, accentColor, ...rest } = props

	const sortedPriorities = useSort(priorities, issueTypePrioritySortFn)

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content variant={variant} size={size} accentColor={accentColor}>
				<Menu.Scroll>
					<IssuePriorityMultiSelectGroup
						values={values}
						priorities={sortedPriorities}
						onValuesChange={onValuesChange}
					/>
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
IssuePriorityMultiSelect.displayName = "IssuePriorityMultiSelect"
